
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import {  Row, Col } from 'antd';
import './index.css';
import ReactEchart from 'echarts-for-react';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';


const GraphContainer = styled.div<CommonStyledComponentProps>`
    margin-top: ${(props: any) => props.isMobile ? "16px" : "0"};
    border-radius: 8px;
    height: auto;
    background-color: transparent;
`;

const FolioGraph: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));

    const graphOptions = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: `${!isMobile ? 'middle' : 'bottom'}`,
            bottom: `${isMobile ? '10' : 'middle'}`,
            right: `${isMobile ? '0' : '50'}`,
            left: `${isMobile ? '0' : '300'}`,
            orient: 'vertical',
            itemWidth: 14,
            itemHeight: 14,
            borderRadius: '50%',
            type: 'scroll',
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                radius: ['30%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
               
                labelLine: {
                    show: false
                },
                width: `${isMobile ? '100%' : '50%'}`
            }
        ]
    }
    return <GraphContainer isMobile={isMobile}>
        <h3 className='portfolioHead'>ASSET DISTRIBUTION</h3>
        <div className="rowNew1">
            <Row gutter={16}>
                <Col xs={12}>
                    <ReactEchart option={{ ...graphOptions, series: [{ ...graphOptions.series[0], data: portfolioDetails?.categoryDistribution }] }} />
                </Col>
                <Col xs={12}>
                    <ReactEchart option={{ ...graphOptions, series: [{ ...graphOptions.series[0], data: portfolioDetails?.subCategoryDistribution }] }} />
                </Col>
            </Row>
        </div>

    </GraphContainer>;
}

export default FolioGraph;
